import {
  SingleApiResponse,
  SuccessApiResponse
} from '@ianesthesie-kit/services';
import axios from 'axios';
import { UserConfig } from './userConfig.model';
import { ApiLanguage } from '@ianesthesie-kit/config';

export class UserConfigService {
  private static readonly INSTANCE: UserConfigService = new UserConfigService();

  private readonly url: string;

  private constructor() {
    this.url = '/bff/patient';
  }

  public static getInstance() {
    return this.INSTANCE;
  }

  public fetch(): Promise<SingleApiResponse<UserConfig>> {
    return axios
      .get<SingleApiResponse<UserConfig>>(`${this.url}/config`)
      .then((r) => r.data);
  }

  public changeLanguage(
    language: ApiLanguage
  ): Promise<SingleApiResponse<UserConfig>> {
    return axios
      .put<SingleApiResponse<UserConfig>>(
        `${this.url}/language?language=${language}`
      )
      .then((r) => r.data);
  }

  public toggleMarketingCommsStatus(): Promise<SingleApiResponse<UserConfig>> {
    return axios
      .put<SingleApiResponse<UserConfig>>(`${this.url}/marketing-comms-status`)
      .then((r) => r.data);
  }

  public toggleClimicalTrialOptOut(): Promise<SuccessApiResponse> {
    return axios
      .put<SuccessApiResponse>(`${this.url}/clinical-trial-opt-out`)
      .then((r) => r.data);
  }

  public optOutEmailCommunication(): Promise<SuccessApiResponse> {
    return axios
      .post<SuccessApiResponse>(`/auth/email/communication-opt-out`)
      .then((r) => r.data);
  }
}
